<template>
  <v-autocomplete
    v-model="model"
    variant="outlined"

    color="secondary"
    :label="required ? '*' + label : label"
    :hint="hint"
    :error-messages="errorMessages"
    :loading="dataLoading"

    :name="fieldKey"
    :items="dataItems"
    :item-title="itemText"
    :item-value="itemValue"

    chips
    multiple
    closable-chips
    :disabled="disabled"
  >
    <!-- 選択済みの表示 -->
    <template #chip="{props, item}">
      <v-chip
        v-bind="props"
        :color="chipColor(item.raw[itemValue])"
        :label="designLabel"
        close
        class="chip--select-multi"
        :text="getItemText(item.raw[itemText])"
        size="large"
        @input="remove(item)"
      >
        <template
          v-if="item.raw[iconFileKey]"
          #prepend
        >
          <img
            :src="image(item.raw[iconFileKey])"
            height="20"
            alt="icon"
          >
        </template>
      </v-chip>
    </template>

    <!-- 選択候補の表示 -->
    <template #item="{ props, item }">
      <v-list-item
        v-bind="props"
        :title="getItemText(item.raw[itemText])"
        density="compact"
        class="text-secondary"
      >
        <template #prepend>
          <v-list-item-action start>
            <v-checkbox-btn :model-value="isSelected(item.raw[itemValue])" />
          </v-list-item-action>
          <img
            :src="image(item.raw[iconFileKey])"
            height="40"
          >
        </template>
        <v-list-item-subtitle
          v-if="subTitleKey"
          class="text-grey"
        >
          {{ item.raw[subTitleKey] }}
        </v-list-item-subtitle>
      </v-list-item>
    </template>

    <!-- 見つからない場合 -->
    <template #no-data>
      <v-layout
        v-show="!ui.loading"
        justify-center
        class="text-grey py-3"
      >
        {{ $t('NoItems') }}
      </v-layout>
    </template>
  </v-autocomplete>
</template>

<script>
  import ServiceIconMixin from '@/components/parts/mixins/ServiceIconMixin'
  import SelectItemMixin from './SelectItemMixin'

  export default {
    mixins: [ServiceIconMixin, SelectItemMixin],
    props: {
      iconFileKey: {
        type: String,
        default: ''
      }
    }
  }
</script>
